import PropTypes from "prop-types";

import styles from "./ActionIcon.module.css";

import webLinkIcon from "../../assets/webLink.svg";
import mediaIcon from "../../assets/Play_Icon.svg";

import HeartIcon from "../../assets/Heart_Icon.svg";
import NotifyIcon from "../../assets/Notify_Icon.svg";
import NotifyActiveIcon from "../../assets/NotificationActivatedIcon.svg";
import OptionsIcon from "../../assets/Options_Icon.svg";
import NewCartIcon from "../../assets/Cart_Icon.svg";
import StoreReadIcon from "../../assets/Store_Read.svg";
import ReadIcon from "../../assets/Read.svg";
import NoteIcon from "../../assets/Circle_Circle_Note_Icon.svg";

import HeartClickedIcon from "../../assets/Heart_Clicked_Icon.svg";

export function ActionIcon({ onClick, iconType, disabled = false }) {
  let icon;

  switch (iconType) {
    case "cart":
      icon = NewCartIcon;
      break;
    case "media":
      icon = mediaIcon;
      break;
    case "Amway":
      icon = webLinkIcon;
      break;
    case "more":
      icon = OptionsIcon;
      break;
    case "like":
      icon = HeartIcon;
      break;
    case "likeActive":
      icon = HeartClickedIcon;
      break;
    case "notify":
      icon = NotifyIcon;
      break;
    case "notifyActive":
      icon = NotifyActiveIcon;
      break;
    case "storeRead":
      icon = StoreReadIcon;
      break;
    case "Read":
      icon = ReadIcon;
      break;
    case "note":
      icon = NoteIcon;
      break;
    default:
      icon = null;
  }

  return (
    <div
      className={styles.actionIcon}
      onClick={disabled ? undefined : onClick}
      aria-busy={disabled || undefined}
      aria-disabled={disabled || undefined}
    >
      <img src={icon} alt={`${iconType} icon`} />
    </div>
  );
}

ActionIcon.propTypes = {
  iconType: PropTypes.oneOf([
    "cart",
    "media",
    "Amway",
    "more",
    "like",
    "likeActive",
    "notify",
    "notifyActive",
    "storeRead",
    "Read",
    "note",
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
